import { HCConfig, HCConfigAssets, HCConfigFeatures, HCConfigRules } from './hc-config';

export const conexao: HCConfig = {
         appName: 'Conexão Saúde Digital',
         hcId: '',
         isPublic: true,
         uf: 'AM',
         config: {
           trackingId: 'G-ZG35Y9W9QV',
           domain: 'app.conexaosaudepovos.com.br',
           domainKey: 'appPovosDaFlorestaDomainUrl',
           reactDomainKey: 'appPovosDaFlorestaDomainReactUrl',
           hcParam: 'povosdafloresta',
           clientDomain: 'CONEXAOPOVOSFLORESTA',
           clientDomainHeader: 'CONEXAOPOVOSFLORESTA',
           govBrClientId: 'cuidar-piaui-gov-pi',
         },
         assets: {
           logo: HCConfigAssets.mainLogo('conexao'),
           uploadExternalFilesLogo: HCConfigAssets.uploadExternalFilesLogo('conexao'),
           preloaderLogo: HCConfigAssets.preloaderLogo('conexao'),
           favicon: HCConfigAssets.favicon('conexao'),
         },
         links: {
           site: 'https://app.conexaosaudepovos.com.br',
           termsOfUse: 'https://conexaosaudepovos.com.br/termos-de-uso-conexao-saude.html',
           policyPrivacy: 'https://conexaosaudepovos.com.br/politica-de-privacidade-conexao-saude.html',
           playstore: 'https://play.google.com/store/apps/details?id=com.ptm.conexaopovosfloresta',
           appstore: 'https://apps.apple.com/br/app/conex%C3%A3o-sa%C3%BAde/id6736998071',
         },

         dataDeletion: {
           name: 'Povos da Floresta Saúde Digital',
           slug: 'povos-da-floresta',
           agreementTermsUrl:
             'https://conexaosaudepovos.com.br/termo-de-consentimento-exclusao-conta-conexao-saude.html',
           background: '#ffffff',
           logo: {
             src: HCConfigAssets.dataDeletionLogo('conexao'),
             width: 291,
             height: 180,
           },
         },

         firstAccess: {
           name: 'Conexão Saúde',
           city: 'Conexão Saúde',
           slug: 'povos-da-floresta',
           abbreviation: 'register',
           background: 'linear-gradient(45deg, #2d8efb, #034ea2 35%, #023f82)',
           logo: {
             src: HCConfigAssets.firstAccessLogo('conexao'),
             width: 200,
             height: 180,
           },
         },

         mealPlan: {
           enableDocumentCreation: false,
           enableSendFiles: true,
           documentTypes: {
             showMealPlan: true,
             showTherapeuticPlan: false,
             showNursingPlan: false,
           },
         },

         routes: {
           firstAccess: '/first-access/povos-da-floresta',
         },

         features: [
           HCConfigFeatures.FIRST_ACCESS_REGISTER,
           HCConfigFeatures.HC_ADM_CAN_CHANGE_PATIENT_PASSWORD,
           HCConfigFeatures.ENABLE_FIRST_ACCESS,
           HCConfigFeatures.MANCHESTER_QUESTIONNAIRE,
           HCConfigFeatures.CAMERA_MIC_PREVIEW_BEFORE_CALL_JOIN,
         ],
         rules: [
           HCConfigRules.PATIENT_INVITE_AND_EDIT_FORM_REQUIRE_CPF_OR_EMAIL,
           HCConfigRules.PHYSICIAN_SIGNATURE_STATUS_WIDGET,
           HCConfigRules.DOCTORS_LIST_SHOW_DIGITAL_SIGNATURE_STATUS,
         ],
       };
